import { Button, Table } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useUserLicensesTrials } from "../../../hooks/users/useUserLicensesTrials";
import { useState } from "react";
import { MelcoModelsUserTrialListItem } from "melco-shared-logic";
import { ExtendTrialDrawer } from "../drawer/ExtendTrialDrawer";
import { ExtendTrialActionButtonInterface } from "../ExtendTrialActionButton";

type LicensesTrialsListPropTypes = {
  userId: string;
  productCode: string;
  refetchUserProductsCallBack: () => void;
};

export const UserLicensesTrialsList: React.FC<LicensesTrialsListPropTypes> = ({
  userId,
  productCode,
  refetchUserProductsCallBack,
}) => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    refetch,
    onTableConfigChange,
  } = useUserLicensesTrials(userId, productCode);

  const { t } = useTranslation();
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [extendTrialActionDetailValues, setExtendTrialActionDetailValues] =
    useState<ExtendTrialActionButtonInterface>({
      product_code: productCode,
      product_version_number: "",
      userIdToExtendTrial: userId,
    });

  const extendTrialAction = (row: MelcoModelsUserTrialListItem) => {
    setExtendTrialActionDetailValues({
      product_code: productCode,
      product_version_number: row?.product_version_number ?? "",
      userIdToExtendTrial: userId,
    });
    setDrawerOpen(true);
  };

  const onCloseDrawer = (drawerOpen: boolean) => {
    refetch();
    refetchUserProductsCallBack();
    setDrawerOpen(drawerOpen);
  };

  const columns = [
    {
      title: t("users.tabs.trials.table.columns.product_level"),

      key: "product_level_name",
      dataIndex: "product_level_name",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.trials.table.columns.trial_started_on"),
      key: "start_date",

      width: 30,
      render: (row: MelcoModelsUserTrialListItem) => {
        return row.start_date ? new Date(row.start_date).toLocaleString() : "";
      },
    },
    {
      title: t("users.tabs.trials.table.columns.trial_expires_on"),

      key: "end_date",

      width: 30,
      render: (row: MelcoModelsUserTrialListItem) => {
        return row.end_date ? new Date(row.end_date).toLocaleString() : "";
      },
    },

    {
      title: t("users.tabs.trials.table.columns.actions"),
      key: "",
      dataIndex: "",
      //sorter: true,
      width: 30,
      render: (row: MelcoModelsUserTrialListItem) => {
        return (
          <Button type="primary" onClick={() => extendTrialAction(row)}>
            {t("users.tabs.trials.actions.extendtrial.button")}
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <div>
        <Table
          //  showSorterTooltip={false}
          sticky
          loading={isPreviousData ? isFetching : isLoading}
          dataSource={data}
          columns={columns}
          onChange={onTableConfigChange}
          //pagination={pagination}
          pagination={false}
          rowKey="id"
          // rowSelection={rowSelection}
          // onRow={onRow}
          noDataMessage={t("users.tabs.trials.no_trials_message")}
          errorComponent={errorComponent}
          //scroll={{ x: 1700 }}
        />
      </div>

      {isDrawerOpen && (
        <ExtendTrialDrawer
          ExtendTrialActionDetailValues={extendTrialActionDetailValues}
          isDrawerOpen={isDrawerOpen}
          onCloseDrawer={onCloseDrawer}
        />
      )}
    </>
  );
};
